import AbstractApiActionTypes from "services/cores/abstractApiActionTypes";

const ParkedCarsActionTypes = new AbstractApiActionTypes("parkedCars");

export default ParkedCarsActionTypes;
